package app.footyguide.core.locale

import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.staticCompositionLocalOf

/**
 * CompositionLocals para locale + idioma em toda a árvore Compose.
 *
 * Dois conceitos separados:
 *   LocalBroadcastMarket  → país de transmissão (ex: "US" para BR morando nos EUA)
 *   LocalStrings          → strings do idioma escolhido (ex: PT mesmo no locale US)
 *
 * Uso na raiz do app (MainActivity / FootyGuideApp):
 *
 *   val locale   = userPrefs.locale      // "US"
 *   val language = UiLanguage.fromCode(userPrefs.language)  // PT
 *
 *   CompositionLocalProvider(
 *     LocalBroadcastMarket provides locale,
 *     LocalStrings provides Strings.forLanguage(language),
 *   ) {
 *     FootyGuideNavHost(...)
 *   }
 *
 * Uso em qualquer Composable:
 *
 *   val s      = LocalStrings.current
 *   val market = LocalBroadcastMarket.current  // para channelsFor(market)
 *
 *   Text(s.today)
 *   val channels = game.channelsFor(market)
 */

/** Mercado de transmissão do usuário (código ISO do país). */
val LocalBroadcastMarket = staticCompositionLocalOf<String> { BroadcastMarket.default }

/** Strings localizadas para o idioma escolhido pelo usuário. */
val LocalStrings = compositionLocalOf<AppStrings> {
    Strings.forLanguage(UiLanguage.default)
}
